import '~style/blocks/logo/_logos.scss';

import Swiper from 'swiper';
import 'swiper/css';
import { Navigation } from 'swiper/modules'

new Swiper('.js-logos .swiper-container', {
  slidesPerView: '1',
  spaceBetween: 100,
  watchOverflow: true,
  autoplay: 5000,
  loop: true,
  modules: [ Navigation ],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: '2',
    },
    1024: {
      slidesPerView: 'auto',
    },
  },
});
